<template>
    <div class="dot-loader" :class="rootClasses">
        <div v-for="dot in 3" class="dot-loader--dot"></div>
    </div>
</template>

<script>
    import bemMixin from 'framework/mixins/bem';


    export default {
        mixins: [
            bemMixin('dot-loader'),
        ],
        props: {
            isActive: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
            rootClasses() {
                return [
                    this.bemFacet,
                    this.bemAdd(this.isActive ? 'is-active' : ''),
                ];
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/dot-loader/index.vue?d1e548b2